export interface Work {
  id: string;
  title: string;
  categoryId: string;
  categoryName: string;
  cover: string;
  status: "连载中" | "已完结";
  episodes: number;
  views: string;
  likes: string;
  rating: number;
  tag: string;
  updateAt: string;
  desc: string;
  featured?: boolean;
}

export const works: Work[] = [
  {
    id: "w001",
    title: "剑破九霄",
    categoryId: "xuanhuan",
    categoryName: "玄幻仙侠",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20manhua%20cover%2C%20young%20swordsman%20in%20flowing%20white%20robes%20holding%20a%20glowing%20spirit%20sword%2C%20misty%20cloud%20mountains%20background%2C%20warm%20gold%20and%20orange%20lighting%2C%20dynamic%20comic%20artwork%2C%20high%20detail%2C%20epic%20fantasy&width=720&height=960&seq=work-jianpo&orientation=portrait",
    status: "连载中",
    episodes: 128,
    views: "3.2亿",
    likes: "528万",
    rating: 9.4,
    tag: "逆天改命",
    updateAt: "今日更新",
    desc: "少年剑心被废，却意外觉醒上古剑魂。一柄神剑，斩碎九霄九天，从废柴到剑仙，一场逆天改命的仙侠传奇就此开启。",
    featured: true,
  },
  {
    id: "w002",
    title: "都市最强兵王",
    categoryId: "dushi",
    categoryName: "都市异能",
    cover: "https://readdy.ai/api/search-image?query=Urban%20military%20manhua%20cover%2C%20young%20man%20in%20black%20tactical%20gear%20standing%20in%20neon%20city%20night%2C%20teal%20and%20orange%20neon%20glow%2C%20dynamic%20comic%20artwork%2C%20high%20detail%2C%20cool%20urban%20hero%20vibe&width=720&height=960&seq=work-bingwang&orientation=portrait",
    status: "连载中",
    episodes: 356,
    views: "5.8亿",
    likes: "921万",
    rating: 9.2,
    tag: "热血逆袭",
    updateAt: "今日更新",
    desc: "昔日的特种兵王回归都市，扮猪吃虎隐藏身份。为了守护心爱之人，他一步步掀翻黑暗世界，重塑都市秩序。",
    featured: true,
  },
  {
    id: "w003",
    title: "偷偷藏不住的心动",
    categoryId: "aiqing",
    categoryName: "甜宠恋爱",
    cover: "https://readdy.ai/api/search-image?query=Cute%20romance%20manhua%20cover%2C%20shy%20girl%20and%20handsome%20boy%20almost%20touching%20hands%20under%20falling%20cherry%20blossoms%2C%20soft%20pink%20and%20peach%20tones%2C%20sweet%20dreamy%20comic%20artwork%2C%20high%20detail%2C%20romantic%20atmosphere&width=720&height=960&seq=work-toutou&orientation=portrait",
    status: "已完结",
    episodes: 96,
    views: "4.5亿",
    likes: "788万",
    rating: 9.6,
    tag: "双向暗恋",
    updateAt: "完结",
    desc: "那个藏在心里不敢说出口的秘密，终于在某个夏天被彼此发现。一场关于青春与心动的甜蜜双向暗恋，甜到冒泡。",
    featured: true,
  },
  {
    id: "w004",
    title: "迷雾迷城",
    categoryId: "xuanyi",
    categoryName: "悬疑惊悚",
    cover: "https://readdy.ai/api/search-image?query=Dark%20mystery%20manhua%20cover%2C%20mysterious%20detective%20figure%20holding%20magnifying%20glass%20in%20foggy%20night%20city%2C%20moody%20teal%20and%20shadow%20lighting%2C%20eerie%20suspense%20comic%20artwork%2C%20high%20detail%2C%20cinematic%20thriller&width=720&height=960&seq=work-miwu&orientation=portrait",
    status: "连载中",
    episodes: 82,
    views: "2.1亿",
    likes: "356万",
    rating: 9.0,
    tag: "烧脑悬疑",
    updateAt: "3天前",
    desc: "一桩尘封多年的连环迷案，把实习刑警卷入层层迷雾。真相与谎言交织，这座迷城的秘密远比想象中更加可怕。",
  },
  {
    id: "w005",
    title: "青春必修课",
    categoryId: "xiaoyuan",
    categoryName: "校园青春",
    cover: "https://readdy.ai/api/search-image?query=School%20campus%20manhua%20cover%2C%20happy%20students%20in%20uniforms%20under%20cherry%20blossom%20trees%2C%20bright%20sunny%20day%2C%20fresh%20colorful%20palette%2C%20nostalgic%20youth%20comic%20artwork%2C%20high%20detail%2C%20warm%20sunlight&width=720&height=960&seq=work-qingchun&orientation=portrait",
    status: "连载中",
    episodes: 145,
    views: "3.6亿",
    likes: "642万",
    rating: 9.1,
    tag: "青春校园",
    updateAt: "今日更新",
    desc: "转学少女踏入陌生校园，遇到一群性格迥异的同学。友情、梦想与心动交织，属于每个人的青春必修课正式开课。",
  },
  {
    id: "w006",
    title: "废柴逆袭记",
    categoryId: "xianxia",
    categoryName: "逆袭爽文",
    cover: "https://readdy.ai/api/search-image?query=Underdog%20manhua%20cover%2C%20determined%20young%20hero%20standing%20with%20glowing%20golden%20power%20breaking%20chains%2C%20epic%20battle%20background%2C%20dynamic%20comic%20artwork%2C%20orange%20and%20crimson%20energy%20bursts%2C%20high%20detail%2C%20dramatic%20lighting&width=720&height=960&seq=work-feichai&orientation=portrait",
    status: "连载中",
    episodes: 268,
    views: "6.2亿",
    likes: "1105万",
    rating: 9.3,
    tag: "逆袭打脸",
    updateAt: "今日更新",
    desc: "被所有人嘲笑的废柴，却在绝境中觉醒隐藏血脉。一路逆袭打脸，从人人可欺的废物，成为震撼大陆的至尊强者。",
    featured: true,
  },
  {
    id: "w007",
    title: "狐妖缘缘传",
    categoryId: "dongfang",
    categoryName: "东方奇幻",
    cover: "https://readdy.ai/api/search-image?query=Oriental%20fantasy%20manhua%20cover%2C%20mystical%20fox%20spirit%20girl%20in%20traditional%20hanfu%20with%20glowing%20eyes%20and%20nine%20tails%2C%20ancient%20forest%20background%2C%20ethereal%20gold%20and%20teal%20lighting%2C%20magical%20comic%20artwork%2C%20high%20detail&width=720&height=960&seq=work-huyao&orientation=portrait",
    status: "已完结",
    episodes: 210,
    views: "7.8亿",
    likes: "1532万",
    rating: 9.7,
    tag: "东方美学",
    updateAt: "完结",
    desc: "修行千年的狐妖下山历劫，却与凡间少年结下不解之缘。妖与人、缘与劫，一段跨越物种的旷世奇恋缓缓展开。",
    featured: true,
  },
  {
    id: "w008",
    title: "重回校园当学神",
    categoryId: "xianxia",
    categoryName: "逆袭爽文",
    cover: "https://readdy.ai/api/search-image?query=Rebirth%20school%20manhua%20cover%2C%20confident%20student%20with%20glasses%20holding%20books%20in%20modern%20classroom%2C%20bright%20academic%20setting%2C%20dynamic%20comic%20artwork%2C%20warm%20orange%20and%20gold%20tones%2C%20high%20detail%2C%20motivational%20vibe&width=720&height=960&seq=work-chonghui&orientation=portrait",
    status: "连载中",
    episodes: 183,
    views: "4.9亿",
    likes: "986万",
    rating: 9.2,
    tag: "重生逆袭",
    updateAt: "2天前",
    desc: "重回高三那年，曾经的学渣带着未来记忆重生。这一次，他要考最顶级学府，惊艳所有曾经嘲笑他的人。",
  },
  {
    id: "w009",
    title: "总裁的甜蜜合约",
    categoryId: "aiqing",
    categoryName: "甜宠恋爱",
    cover: "https://readdy.ai/api/search-image?query=CEO%20romance%20manhua%20cover%2C%20handsome%20young%20CEO%20in%20suit%20and%20elegant%20girl%20in%20modern%20office%2C%20soft%20warm%20pink%20lighting%2C%20sweet%20romantic%20comic%20artwork%2C%20high%20detail%2C%20dreamy%20atmosphere%2C%20luxury%20office%20background&width=720&height=960&seq=work-zongcai&orientation=portrait",
    status: "连载中",
    episodes: 152,
    views: "5.1亿",
    likes: "1023万",
    rating: 9.5,
    tag: "契约恋爱",
    updateAt: "今日更新",
    desc: "为了救回家族产业，她签下一纸甜蜜合约，成为冷面总裁的合约恋人。合约有时限，心动却失控，一场豪门甜宠恋就此展开。",
    featured: true,
  },
  {
    id: "w010",
    title: "夜幕下的守护者",
    categoryId: "xuanyi",
    categoryName: "悬疑惊悚",
    cover: "https://readdy.ai/api/search-image?query=Noir%20suspense%20manhua%20cover%2C%20shadowy%20vigilante%20figure%20in%20trench%20coat%20silhouette%20against%20dark%20city%20skyline%2C%20moody%20mint%20green%20and%20dark%20lighting%2C%20mysterious%20comic%20artwork%2C%20high%20detail%2C%20cinematic%20thriller&width=720&height=960&seq=work-yemu&orientation=portrait",
    status: "连载中",
    episodes: 67,
    views: "1.8亿",
    likes: "298万",
    rating: 8.8,
    tag: "暗夜追凶",
    updateAt: "5天前",
    desc: "当法律无法惩戒罪恶，谁来守护夜幕下的城市？神秘守护者游走于黑白之间，在黑暗中追捕那些藏匿的真相。",
  },
  {
    id: "w011",
    title: "热血篮球少年",
    categoryId: "xiaoyuan",
    categoryName: "校园青春",
    cover: "https://readdy.ai/api/search-image?query=Basketball%20sports%20manhua%20cover%2C%20energetic%20teenager%20dunking%20with%20glowing%20energy%20in%20indoor%20gym%2C%20dynamic%20action%20comic%20artwork%2C%20warm%20orange%20lighting%2C%20high%20detail%2C%20sports%20passion%2C%20motion%20blur%20energy&width=720&height=960&seq=work-lanqiu&orientation=portrait",
    status: "已完结",
    episodes: 124,
    views: "2.7亿",
    likes: "501万",
    rating: 9.0,
    tag: "热血运动",
    updateAt: "完结",
    desc: "矮个子少年怀揣篮球梦想，用汗水与热爱一路突破自我。在全国大赛的赛场上，他向所有人证明：梦想没有身高限制。",
  },
  {
    id: "w012",
    title: "都市奇缘录",
    categoryId: "dushi",
    categoryName: "都市异能",
    cover: "https://readdy.ai/api/search-image?query=Urban%20superpower%20manhua%20cover%2C%20young%20man%20with%20glowing%20mystical%20energy%20in%20modern%20city%20street%2C%20teal%20and%20gold%20neon%20lighting%2C%20dynamic%20comic%20artwork%2C%20high%20detail%2C%20fantasy%20urban%20vibe%2C%20energy%20particles&width=720&height=960&seq=work-qiyuan&orientation=portrait",
    status: "连载中",
    episodes: 214,
    views: "3.3亿",
    likes: "687万",
    rating: 9.1,
    tag: "都市奇遇",
    updateAt: "1天前",
    desc: "都市之中，隐藏着一群拥有超能力的奇人异士。平凡少年偶然卷入其中，从此开启一段光怪陆离的都市奇遇之旅。",
  },
];